/*
 * @Author: weijinpeng
 * @LastEditors: ningrui
 * @Date: 2025-08-07 10:13:42
 * @LastEditTime: 2025-10-31 15:31:25
 * @Description: 
 */
export default {
    PoweredbyMVGX: 'Powered by MVGX',
    Itlooks: 'It looks like you are using a different browser from the one where your data was saved. Kindly switch back to the previous browser, rescan the QR code, or approach our friendly colleague at the booth for assistance.',
    Close: 'Close',
    TotalCarbonFootprint: 'Total Carbon Footprint For Your Trip',
    To: 'to',
    Stat: 'Stat Date',
    End: 'End Date',
    totalemission:'total emission:',
    Trips: 'Trips',
    Stays: 'Stays',
    date: 'Date Selection',
    Thankyoufor: 'Thank you for taking part in our Snap for Sustainability initiative.',
    Yourinputhelps: 'Your input helps MVGX track and reduce the carbon footprint of the World Aquatics Championships, making it greener and more impactful.',
    Yourinputhelps1: '感谢您参加“2025中欧AMP24小时营地节”。基于我们共同的绿色愿景，MVGX将助力中欧AMP量化并降低本次赛事碳足迹，让赛事更绿色低碳，同时为地球带来积极的改变。',
    Together: 'Together, we are creating a meaningful difference for our communities and our planet.',
    CarbonFootprintNeutralized: 'Carbon Footprint Neutralized',
    ThankYouforNeutralizing: 'Thank You for Neutralizing Your Carbon Footprint!',
    NAME: 'NAME',
    EVENTNAME: 'EVENT NAME',
    CARBONNEUTRALISATION: 'CARBON NEUTRALISATION TRANSACTION ID',
    CARBONFOOTPRINT: 'CARBON FOOTPRINT DECLARED',
    DATEOFCARBON: 'DATE OF CARBON NEUTRALITY TOKENS BURNT',
    Your: 'Your',
    tripcarbon: 'trip carbon footprint is being neutralized on the Ethereum blockchain.',
    DownloadCertificate: 'Download Certificate',
    CARBONNEUTRALITYCERTIFICATE: 'CARBON NEUTRALITY CERTIFICATE',
    Thisistocertifythat: 'This is to certify that',
    hasneutralized: 'has neutralized',
    oftheirCarbonFootprint: 'of their Carbon Footprint',
    forthe:'for the',
    CERTIFICATENO: 'CERTIFICATE NO.',
    CARBONNEUTRALITYEVENT: 'CARBON NEUTRALITY EVENT',
    CARBONFOOTPRINTDECLARED: 'CARBON FOOTPRINT DECLARED',
    CARBONCREDITSRETIRED: 'CARBON CREDITS RETIRED',
    CarbonNeutralityTokensburnt: 'Carbon Neutrality Tokens burnt',
    DATEOFCARBONNEUTRALITYTOKENSBURNT: 'DATE OF CARBON NEUTRALITY TOKENS BURNT',
    CERTIFICATIONTEXT: 'CERTIFICATION TEXT',
    hasneutralised: 'has neutralised',
    oftheirCarbonFootprintforthe: 'of their Carbon Footprint for the',
    equivalent:'equivalent',
    EQUIVALENT: 'EQUIVALENT',
    event: 'event.',
    CARBONNEUTRALISATIONTRANSACTIONID: 'CARBON NEUTRALISATION TRANSACTION ID',
    MetaVerseGreenExchange: 'MetaVerse Green Exchange',
    NetZeroDiary: 'Net Zero Diary',
    From:'From',
    To: 'To',
    CarbonFootprint: 'Carbon Footprint',
    CityTrains: 'City Trains',
    Car_Taxi: 'Car/Taxi',
    e_Bike: 'e-Bike',
    Motorcycle: 'Motorcycle',
    Tram: 'Tram',
    Bus: 'Bus',
    Airplane: 'Airplane',
    SeaFerry: 'Sea Ferry',
    Stays: 'Stays',
    City: 'City',
    Night: 'Night(s)',
    bed: '1 bed',
    beds: '2 beds',
    Addaccommodationbeds: 'Add accommodation beds',
    CalculateMyCarbonFootprint: 'Calculate My Carbon Footprint',
    OK: 'OK',
    ChooseTransport: 'Choose Transport',
    IndividualorGroupAccomodation: 'Individual or Group Accomodation',
    Pleasenotethatonceconfirmedthe: 'Please note that once confirmed, the',
    informationsavedcannolongerbemodified: 'information saved can no longer be modified',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    Pleaseselectadate: 'Please select a date',
    Departure: 'Departure',
    Leavingfrom: 'Leaving from',
    Destination: 'Destination',
    Goingto: 'Going to',
    CarbonNeutralFor: 'Carbon Neutral For',
    Description: 'Description',
    IssuedBy: 'Issued By',
    TokenStandard: 'Token Standard',
    Blockchain: 'Blockchain',
    Youwillhavetheoption: 'You will have the option to add a personalized message to your NFT after payment',
    PurchaseNow: 'Purchase Now',
    Sorrythecodelinked: 'Sorry, the code linked to this card is not authorize',
    Email: 'Email',
    Pleasevisit: 'Please visit',
    formoreinformationabout: 'for more information about our products and services.',
    Iagreetosharemypersonaldata: 'I agree to share my personal data.',
    Pleaseenteryournametocontinue: "Please enter your name to continue.",
    Pleaseenteryouremailaddress: 'Please enter your email address to continue.',
    Pleaseenterthecorrectemailaddress: 'Please enter the correct email address',
    Pleaseselectthecheckboxtocontinue: 'Please select the checkbox to continue',
    YourCarbonNeutralisationisinProcess: "Your Carbon Neutralisation is in Process, Please Wait!",
    OrderDetails: 'Order Details',
    NFTName: 'NFT Name',
    CarbonNeutralFor: "Carbon Neutral For",
    NFTAmount: "NFT Amount",
    NameorNickname: "Name or Nickname (required)",
    Addyournameornickname: "Add your name or nickname here to display on your NFT.",
    PersonalizedMessage: "Personalized Message",
    Typeinyourpersonalisedtextsdisplaye: "Type in your personalised texts displayed on your NFT (optional).",
    Iwouldliketodisplay:"I would like to display the purchased NFT on MVGX's web gallery and agree to the terms and conditions in accordance with MVGX's privacy policy.",
    Preview: "Preview",
    GenerateYourNFT: "Generate Your NFT",
    InvalidOrderID: "Invalid Order ID, you will be guided to payment page now.",
    Nameisrequired: "Name is required to generate your NFT",
    FailedtogenerateyourNFT: "Failed to generate your NFT. We're sorry for the inconvenience, please try again later.",
    Maximum64Characters: "Maximum 64 Characters",
    Pleasesetapasscodeforfutureaccess: "Please set a passcode for future access",
    Passcodeis6digits: "Passcode is 6 digits",
    Submit: "Submit",
    Pleasescreenshot: "Please screenshot and save the QR code below",
    ThisQRcode: "This QR code is your unique gateway for all future visits. please safeguard it diligently.",
    Pleaseseta6digitspasscode: "Please set a 6-digits passcode",
    ThisCardHasAlreadyBeenUsed: 'This Card Has Already Been Used To Neutralize Carbon Footprint',
    ThisCardHasBeenSuspended: "This Card Has Been Suspended!",
    ThisCardHasAlreadyExpired: "This Card Has Already Expired!",
    Theaddresshasexpiredandcannotbeaccessed: "The address has expired and cannot be accessed",
    ThisCardHasAlready: "This Card Has Already Been Used To Neutralize Carbon Footprint",
    VisitMVGX: "Visit MVGX",
    Pleasesubmiyourquery: 'Please submit your query via the form below.',
    SerialNo: "Serial No",
    EventName: "Event Name",
    FullName: "Full Name",
    ContactNumber: "Contact Number",
    Ifrequirereply: "If require reply",
    abriefdescription: "a brief description of your request or issues encountered.",
    Send: "Send",
    Wewillreplywithi: "We will reply within 1 business day",
    Pleasebeinformedour: "Please be informed our business hours are every Monday to Friday, from 9 am to 6 pm, excluding public holidays",
    SubmitSuccessful: 'Submit Successful!',
    Pleaseenterthecorrectemailaddress: 'Please enter the correct email address',
    Pleaseenterthequestion: "Please enter the question you want to feedback.",
    Congratulations: "Congratulations! Your NFT Order Has Been Processed Successfully!",
    TheNFTdisplayed: "The NFT displayed above is for illustration purposes only, actual text layout may differ.",
    OCBCPublicSectorDay: "OCBC Public Sector Day",
    TransactionHash: "Transaction Hash",
    TokenID: "Token ID",
    Moredetailshavebeensent: "More details have been sent to your email address",
    Welcome: "Welcome",
    Yourecalculating: "You're calculating your personal carbon footprint!",
    SerialNo: "Serial No",
    EnterPassword: "Enter Password",

    Notice: "Notice",

    Makepledge: "Make a sustainability pledge",
    Makepledge1: "请选择承诺以继续",
    Pleaseteamname: "Please select a team name",
    Pleaseteamname1: "请选择队伍以继续",

    ple0: "自带水杯,减少一次性用品消耗",
    ple01: "低碳赛事，无痕营地",
    ple1: "write my own pledge",
    ple2: "I will bring a reusable bottle every day.",
    ple3: "I will go meat-free for one week.",
    ple4: "I will take public transport instead of driving.",
    ple5: "I will refuse single-use plastic bags.",
    ple6: "I will switch off unused lights and appliances.",
    ple7: "I will recycle properly at home and at work.",
    ple8: "I will fly less and opt for virtual meetings.",
    ple9: "I will buy local and seasonal food.",
    ple10: "I will reduce my shower time to save water.",
    ple11: "I will compost my kitchen waste.",
    ple12: "I will wear more second-hand or sustainable clothing.",
    ple13: "I will carry a reusable shopping bag.",
    ple14: "I will unplug my charger when not in use.",
    ple15: "I will plant a tree this year.",
    ple16: "I will support brands with real climate action.",

    Pledgetxt: 'Pledge Your Action for a Low-Carbon World',
    Footprintbtn: 'Show My Carbon Footprint',
    checktxt: 'By submitting this form,you consent to the collection, use, and disclosure of your personal data including but not limited to your phone number, your likeness, images and/or videos byMVGX for the purposes of participating in the“Snap for Sustainability" fan activation at theWorld Aquatics Championships, sustainability-related reporting and for the access to ourservices. Your personal data shall be collected, used and disclosed in strict compliancy withour Privacy Policy.',
}